import { LoanProgramFieldName } from 'constants/programs';

export const PendingChangesActionType = {
  NO_CHANGES: 'NoChanges',
  MODIFIED: 'Modified',
  DELETED: 'Deleted',
  ADDED: 'Added',
};

export const PendingChangeKind = {
  DIRECT: 'Direct',
  RECALCULATED: 'Recalculated',
};

export const HistoryPendingChangesActionType = {
  MODIFIED: 'EntityModified',
  DELETED: 'EntityDeleted',
  ADDED: 'EntityAdded',
};

export const HistoryTypeToPendingChangesTypeMap = {
  [HistoryPendingChangesActionType.MODIFIED]: PendingChangesActionType.MODIFIED,
  [HistoryPendingChangesActionType.ADDED]: PendingChangesActionType.ADDED,
  [HistoryPendingChangesActionType.DELETED]: PendingChangesActionType.DELETED,
};

export const PendingChangesTypeToHistoryTypeMap = {
  [PendingChangesActionType.MODIFIED]: HistoryPendingChangesActionType.MODIFIED,
  [PendingChangesActionType.DELETED]: HistoryPendingChangesActionType.DELETED,
  [PendingChangesActionType.ADDED]: HistoryPendingChangesActionType.ADDED,
};

// What the recalculation did to a fee; a fee a person changed is never labelled this way.
export const AutomaticFeeChangeLabel = {
  [PendingChangesActionType.ADDED]: 'Added automatically',
  [PendingChangesActionType.MODIFIED]: 'Updated automatically',
  [PendingChangesActionType.DELETED]: 'Removed automatically',
};

export const pendingChangesSimilarFields = ['otherExpenses'];

export const mirroredLoanProgramFields = [
  LoanProgramFieldName.LOAN_TERM,
  LoanProgramFieldName.AMORT_TERM,
  LoanProgramFieldName.PROGRAM_LOAN_TYPE,
  LoanProgramFieldName.AMORTIZATION_TYPE,
];

export const modifiedPendingChanges = [
  PendingChangesActionType.ADDED,
  PendingChangesActionType.DELETED,
  PendingChangesActionType.MODIFIED,
];
